import { render, staticRenderFns } from "./TenantTemplateForm.vue?vue&type=template&id=a903af36&"
import script from "./TenantTemplateForm.vue?vue&type=script&lang=js&"
export * from "./TenantTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./TenantTemplateForm.vue?vue&type=style&index=0&id=a903af36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports